import { create } from 'zustand'
import { getNotificationUnread, type NotificationUnreadData } from '@/lib/api/notification'

const emptyUnread: NotificationUnreadData = {
  system: false,
  personal: false,
  interaction: false,
}

interface NotificationState {
  unread: NotificationUnreadData
  refreshUnread: (signal?: AbortSignal) => Promise<void>
  markTabRead: (tab: 1 | 2 | 3) => void
  reset: () => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  unread: emptyUnread,

  refreshUnread: async (signal) => {
    const response = await getNotificationUnread(signal)
    if (response.code === 200 && response.data) set({ unread: response.data })
  },

  markTabRead: (tab) =>
    set((state) => ({
      unread: {
        ...state.unread,
        [tab === 1 ? 'system' : tab === 2 ? 'personal' : 'interaction']: false,
      },
    })),

  reset: () => set({ unread: emptyUnread }),
}))
